import { atom } from 'jotai';

export const pricingPlansModalOpenAtom = atom(false);

/**
 * Card the marketing `#seat_type` / `#paymentChosen` hash asked to highlight.
 * `practiceMax` is the Max seat of the Practice column (MONEY-1128).
 */
export type PricingPlansHighlightedPlan =
  | 'clinician'
  | 'max'
  | 'practice'
  | 'practiceMax';

export const pricingPlansHighlightedPlanAtom = atom<PricingPlansHighlightedPlan | null>(
  null
);

/** Shown when user chooses “Downgrade to free” from the pricing plans modal (paid → free path). */
export const cancellationConfirmationModalOpenAtom = atom(false);

/** Shown after user confirms “Cancel anyway” on the cancellation confirmation modal (retention offer). */
export const retentionDiscountOfferModalOpenAtom = atom(false);

/** Open when intent API returns clinician_session offer. */
export const clinicianSessionOfferModalOpenAtom = atom(false);

export const cancelTrialDialogOpenAtom = atom<boolean>(false);
